import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import AuthProvider from "./context/AuthProvider";

/**
 * Entry point of the React application.
 * Renders the entire application wrapped in React.StrictMode.
 * Includes authentication provider and BrowserRouter for routing.
 */
ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
